import React from "react";

const _props = {
  selectedPeriod: "",
  periodOptions: [],
  setPeriod: () => {},
};

export const PeriodSwitch = (props = _props) => {
  return (
    <div className="chart_tabs">
      {props.periodOptions.map((x, index) => (
        <div key={index} onClick={() => props.setPeriod(x)} style={{
            backgroundColor: x === props.selectedPeriod ? '#4D80AF' : '#FFFFFF',
            color: x === props.selectedPeriod ? '#FFFFFF' : '#333333'
          }}>
          {x}
        </div>
      ))}
    </div>
  );
};
